import React from 'react'
import { getLink, getLinkFromRef, getMargins } from '../../utility'
import ButtonLinkCtaList from '../link/buttonLinkCtaList.jsx'
import { HippostdHtml } from '../blog/blogArticle/componentTypes/HippostdHtml.jsx'
import { BrManageContentButton } from '@bloomreach/react-sdk'
import './FeatureFund.css'

import { CardUtils } from '../cards/card.util.js'

const RATINGS = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5]

const STAR_ICON = ['star', 'star_border', 'star_half']

const getStarTextColor = (bgColor) => {
  if (
    ['Brand Dark', 'Blue', 'Blue Gradient', 'Dark BG Image'].includes(bgColor)
  ) {
    return 'u-textColorTeal'
  } else if (['Brand', 'Aqua', 'Yellow', 'Green'].includes(bgColor)) {
    return 'u-textColorWhite'
  }
  return 'u-textColorBrand'
}

const FeatureFund = ({ page, component }) => {
  const _parameters = component?.getParameters()

  const parameter = {
    rating: _parameters.rating || 'No Rating',
    marginTop: _parameters.marginTop || 'No Spacing',
    marginBottom: _parameters.marginBottom || 'No Spacing',
    alignment: _parameters.alignment || 'Center',
  }

  const _models = component?.getModels() || {}
  const { document: _documentRef } = _models
  const document = _documentRef && page.getContent(_documentRef)
  const data = document?.getData() || {}

  const { eyebrow, title, body, links, bgColor } = data || {}

  const bgColorStyle = CardUtils.getBackground(bgColor)
  const textColor = CardUtils.getHeadingTextColor(bgColor)
  const starTextColor = getStarTextColor(bgColor)

  const bodyText = body?.html?.value || ''

  const linkList =
    links?.length > 0
      ? links
          ?.filter((l) => l.link && l.link.length > 0)
          ?.map((l) => getLink(getLinkFromRef(l, page), null))
      : []

  const textAlignment =
    parameter?.alignment === 'Center' ? 'u-textCenter' : 'u-textLeft'
  const buttonAlignment =
    parameter?.alignment === 'Center'
      ? 'u-flexJustifyCenter'
      : 'u-flexJustifyStart'

  const showRating = () => {
    if (!parameter.rating || parameter.rating === 'No Rating') {
      return null
    }

    const rating = Number(parameter.rating)

    if (Number.isNaN(rating) || !RATINGS.includes(rating)) {
      return null
    }

    const [full, border, half] = STAR_ICON

    const stars = Array.from({ length: 5 }, (_, index) => {
      const position = index + 1

      if (rating >= position) {
        return full
      }

      if (rating >= position - 0.5) {
        return half
      }

      return border
    })

    return (
      <div
        className="u-marginBottom4gu"
        role="img"
        aria-label={`Rating: ${rating} out of 5 stars`}
      >
        {stars.map((iconName, index) => (
          <React.Fragment key={index}>{starIcon(iconName)}</React.Fragment>
        ))}
      </div>
    )
  }

  const starIcon = (iconName) => (
    <span
      className={`Star Icon--material u-textColorActionBlue u-textSizeMsrp6 ${starTextColor}`}
      role="img"
      title={iconName}
      aria-label={iconName}
      aria-hidden="true"
    >
      {iconName}
    </span>
  )

  return (
    <div
      className={`FeatureFund ${bgColorStyle} ${textAlignment} ${getMargins(parameter.marginTop, parameter.marginBottom)} u-posRelative`}
    >
      {document && <BrManageContentButton content={document} page={page} />}

      <div className="u-sizeConstrained u-paddingVert12gu">
        {eyebrow ? (
          <div
            className={`${textColor} u-textPrimary u-marginBottom8gu u-textBold`}
          >
            {eyebrow}
          </div>
        ) : null}
        {title ? (
          <h3 className={`${textColor} u-marginBottom4gu u-textSizeMsrp3`}>
            {title}
          </h3>
        ) : null}
        <div>{showRating()}</div>
        {bodyText ? (
          <HippostdHtml
            value={bodyText}
            classNames={`${textAlignment} ${textColor} u-textSizeMsrp4 u-marginBottom8gu`}
          />
        ) : null}
        {linkList && linkList.length > 0 && (
          <ButtonLinkCtaList
            ctaWrapperClassNames={`${buttonAlignment} u-flexAlignItemsCenter u-marginTop2gu`}
            linkList={linkList}
          />
        )}
      </div>
    </div>
  )
}

export default FeatureFund
